import { AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getHeaderItemsBuilder(apiClient: AxiosInstance) {
  return async function getHeaderItems(options: {
    profile: string;
    lang?: string;
  }): Promise<IContent.HeaderItemsResponse | null> {
    try {
      const response = await apiClient.get("/header-items/", {
        params: options,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };
}
